module.exports = __webpack_public_path__ + "static/media/Logo-en.bc10c5b6.svg";